import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";


const ClientFeedbackServices = {
  clientfeedbackRequestList: async (body) => {
    const id_employee =await getEmployeeId(); 
    return requests.post(
      `/client/getAllClientFeedbackList/${id_employee}`,
      body
    );
  },

  clientfeedbackOnTourList: async (id, body) => {
    return requests.put(`/client/updateOnTourFeedback/${id}`, body);
  },

  sendFeedbackSms: async (id, body) => {
    return requests.post(`/client/sendClientFeedbackSMS/${id}`, body);
  },

  updateClientEscalation: async (id, body) => {
  return requests.put(`/client/updateClientOntourEscalation/${id}`, body);
},
  getClientEscalation(id, body) {
    return requests.get(`/client/getClientEscalation/${id}`, body);
  },

  getClientOnTourFeedback: async (id, body) => {
    return requests.get(`/client/getOnTourFeedback/${id}`, body);
  },

  getAllOntourEscalate: async (body) => {
    const id_employee =await getEmployeeId(); 
    return requests.post(
      `/client/getAllOntourEscalateList/${id_employee}`,
      body
    );
  },

};

export default ClientFeedbackServices;
